import { fetchWithAuth } from "../../../../api-client/APIClient";
import { User } from "../../../../models/Entities";

const acceptTerms = (): Promise<User> =>
  new Promise((resolve, reject) => {
    fetchWithAuth({
      path: "/users/me",
      method: "PATCH",
      body: { all_terms_agreed: true },
      onResponse: (data: { user: User }) => resolve(data.user),
      onError: reject,
    });
  });

export default acceptTerms;
